import createIcon from '../../icons/createIcon';

const IconCautionCircleFilled = createIcon('IconCautionCircleFilled', '0 0 64 64', [
    [
        'path',
        {
            'fill-rule': 'evenodd',
            'clip-rule': 'evenodd',
            d: 'M56 32C56 45.2548 45.2548 56 32 56C18.7452 56 8 45.2548 8 32C8 18.7452 18.7452 8 32 8C45.2548 8 56 18.7452 56 32ZM10.2 28.1C10.2 28.1552 10.1552 28.2 10.1 28.2C10.0448 28.2 10 28.1552 10 28.1C10 28.0448 10.0448 28 10.1 28C10.1552 28 10.2 28.0448 10.2 28.1ZM29.8372 40.9643C30.4186 40.4167 31.1395 40.1429 32 40.1429C32.8605 40.1429 33.5698 40.4167 34.1279 40.9643C34.7093 41.5357 35 42.2381 35 43.0714C35 43.9048 34.7093 44.5952 34.1279 45.1429C33.5698 45.7143 32.8605 46 32 46C31.1395 46 30.4186 45.7143 29.8372 45.1429C29.2791 44.5952 29 43.9048 29 43.0714C29 42.2381 29.2791 41.5357 29.8372 40.9643ZM34.407 18V37.7857H29.5233V18H34.407Z',
            fill: '#191B21',
            key: '3dee76'
        },
        []
    ]
]);

export { IconCautionCircleFilled };
